import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculator-item.component.scss';
var WpbbsaCalculatorItem = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorItem, _super);
    function WpbbsaCalculatorItem(element) {
        return _super.call(this, element) || this;
    }
    WpbbsaCalculatorItem.prototype.init = function () { };
    WpbbsaCalculatorItem.prototype.bindEvents = function () { };
    return WpbbsaCalculatorItem;
}(Base));
export { WpbbsaCalculatorItem };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-item/wpbbsa-calculator-item.component.ts
// module id = 992
// module chunks = 0